import { createSliceContext } from "./CreateSliceContext";

interface FooterCtaSliceProps {
  field_title: string;
  field_link: {
    url: string;
    title: string;
  } | null;
  relationships: {
    field_media?: {
      relationships: {
        field_media_file: {
          publicUrl: string;
        };
      };
    };
  };
}

export const {
  Provider: FooterCtaSliceProvider,
  useContext: useFooterCtaSliceContext,
} = createSliceContext<FooterCtaSliceProps>("FooterCta");
